import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_pending_actions_slider = _resolveComponent("skeleton-pending-actions-slider")
  const _component_base_title = _resolveComponent("base-title")
  const _component_notification_action = _resolveComponent("notification-action")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_slider_container = _resolveComponent("slider-container")

  return ($options.isComponentVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isProcessing)
          ? (_openBlock(), _createBlock(_component_skeleton_pending_actions_slider, { key: 0 }))
          : ($options.hasPendingActions)
            ? (_openBlock(), _createBlock(_component_slider_container, {
                key: 1,
                "arrow-style": "circle",
                "display-arrows": $options.hasControls,
                centered: false,
                "slides-wrapper-class": "gfu-pending-actions-wrapper",
                "slides-class": "gfu-pending-actions-slides",
                "data-qa": "pending-actions-slider"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_base_title, {
                    as: "h2",
                    level: "h2",
                    class: "_mb-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.SectionRequiresActionHeader), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pendingActions, (action) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: action.userPendingActionID,
                      class: "gfu-pending-action gfu-11of12 gfu-3of4--m gfu-1of2--l _shrink-0 _grow-0"
                    }, [
                      _createVNode(_component_notification_action, _mergeProps({ ref_for: true }, action, { onActionDismissed: $options.onActionDismissed }), null, 16 /* FULL_PROPS */, ["onActionDismissed"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                controls: _withCtx(({ onScrollLeft, onScrollRight, isOverflownLeft, isOverflownRight }) => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_base_button, {
                      theme: "white",
                      shape: "circle",
                      shadow: "tight",
                      class: "_ba-0",
                      "aria-label": _ctx.Resources.Common.ScrollLeftButtonLabel,
                      disabled: !isOverflownLeft,
                      onClick: onScrollLeft,
                      "data-qa": "left-arrow-button"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          name: "chevron-left",
                          class: "_tc--accent",
                          size: "lg"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["aria-label", "disabled", "onClick"]),
                    _createVNode(_component_base_button, {
                      theme: "white",
                      shape: "circle",
                      shadow: "tight",
                      class: "_ba-0",
                      "aria-label": _ctx.Resources.Common.ScrollRightButtonLabel,
                      disabled: !isOverflownRight,
                      onClick: onScrollRight,
                      "data-qa": "right-arrow-button"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          name: "chevron-right",
                          class: "_tc--accent",
                          size: "lg"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["aria-label", "disabled", "onClick"])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["display-arrows"]))
            : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}